import React from "react";
import ctl from "@netlify/classnames-template-literals";

import { howItWorksSection } from "config/drivers";
import { Ntext } from "components";

import { HowItWorksCard } from "./how-it-works-card";

const { title, cardsData } = howItWorksSection;

const HowNombaQRWorks = () => {
  return (
    <section className={wrapperStyle}>
      <Ntext
        value={title}
        color="primary-100"
        className="!font-normal md:!text-[56px] md:!leading-[64px] !-tracking-[2px] text-center"
        variant="h1"
      />
      <section className={cardsStyle}>
        {cardsData.map(card => (
          <HowItWorksCard key={card.instruction} {...card} />
        ))}
      </section>
    </section>
  );
};

const wrapperStyle = ctl(`
  flex
  flex-col
  items-center
  space-y-16
  bg-n-smoky
  w-screen
  relative
  lg:pb-40
  pb-24
`);

const cardsStyle = ctl(`
  flex
  flex-col
  space-y-6
  items-center
  justify-center
  lg:overflow-scroll
  lg:scrollbar-hide
  lg:px-[120px]
  lg:space-y-0
  lg:space-x-4
  lg:flex-row
  w-full
  px-6
`);

export { HowNombaQRWorks };
